import React from 'react'

import {
  PrivacyPolicyContainer,
  PrivacyPolicyCard,
  PrivacyPolicyTitle,
  PrivacyPolicySectionTitle,
  PrivacyPolicyText,
  PrivacyPolicyNote,
} from '../styles/pages/PrivacyPolicyPageStyle'

const PrivacyPolicyPage = () => {
  return (
    <PrivacyPolicyContainer>
      <PrivacyPolicyCard elevation={4}>
        <PrivacyPolicyTitle variant="h4">Privacy Policy</PrivacyPolicyTitle>
        <PrivacyPolicyNote variant="body2">
          ⚠ TODO: Doplnit datum poslední aktualizace (povinné dle čl. 13 GDPR).
        </PrivacyPolicyNote>

        <PrivacyPolicySectionTitle variant="h6">Data Controller</PrivacyPolicySectionTitle>
        <PrivacyPolicyNote variant="body2">
          ⚠ TODO (GDPR čl. 13 odst. 1a): Chybí identita správce — doplnit název organizace, adresu sídla a kontaktní
          e-mail. Bez těchto údajů stránka nesplňuje minimální požadavky GDPR. Př.: „Správcem osobních údajů je
          [Název s.r.o.], IČO [XXXXXXXXXX], sídlem [Ulice, Město], kontakt: gdpr@example.cz“
        </PrivacyPolicyNote>
        <PrivacyPolicyNote variant="body2">
          ⚠ TODO (GDPR čl. 13 odst. 1b): Uvést kontaktní údaje pověřence pro ochranu osobních údajů (DPO), pokud byl
          jmenován, nebo explicitně uvést, že DPO jmenován nebyl.
        </PrivacyPolicyNote>

        <PrivacyPolicySectionTitle variant="h6">What We Process</PrivacyPolicySectionTitle>
        <PrivacyPolicyText variant="body1">
          We process account identifiers (username), authentication data, and operation data needed to run this
          application. We use browser session storage for authentication/session state and local storage for UI layout
          preferences.
        </PrivacyPolicyText>
        <PrivacyPolicyNote variant="body2">
          ⚠ TODO (GDPR čl. 13 odst. 1e): Chybí zmínka o zpracování IP adres v serverových přístupových lozích
          (Apache access.log). IP adresa je osobní údaj — musí být uvedena jako kategorie zpracovávaných dat.
        </PrivacyPolicyNote>

        <PrivacyPolicySectionTitle variant="h6">Cookies and Similar Technologies</PrivacyPolicySectionTitle>
        <PrivacyPolicyText variant="body1">
          This application does not use first-party analytics or marketing cookies. Authentication is handled via
          tokens stored in browser session storage. Local storage is used only for non-essential UI preference values
          (for example column layout).
        </PrivacyPolicyText>

        <PrivacyPolicySectionTitle variant="h6">Why We Process Data</PrivacyPolicySectionTitle>
        <PrivacyPolicyText variant="body1">
          Data is processed for account security, user authentication, and operation of application features.
          Processing is based on legitimate interest and service operation requirements.
        </PrivacyPolicyText>
        <PrivacyPolicyNote variant="body2">
          ⚠ TODO (GDPR čl. 13 odst. 1c): Právní základ „legitimate interest“ je příliš vágní. Pro každý účel
          zpracování je nutné uvést konkrétní základ dle čl. 6 odst. 1 GDPR — např. plnění smlouvy (písm. b),
          oprávněný zájem (písm. f) s jeho popisem, nebo právní povinnost (písm. c). Rovněž je nutné uvést konkrétní
          oprávněné zájmy správce, pokud se opíráte o čl. 6 odst. 1 písm. f.
        </PrivacyPolicyNote>

        <PrivacyPolicySectionTitle variant="h6">Retention</PrivacyPolicySectionTitle>
        <PrivacyPolicyText variant="body1">
          User account data is retained only as long as required for system operation and legal obligations. Security
          event logging persistence is disabled.
        </PrivacyPolicyText>
        <PrivacyPolicyNote variant="body2">
          ⚠ TODO (GDPR čl. 13 odst. 2a): „As long as required“ nestačí — je nutné uvést konkrétní dobu uchování nebo
          kritéria pro její stanovení. Např.: „Uživatelské účty jsou uchovávány po dobu trvání pracovního poměru +
          X let.“ Pro Apache access logy uvést konkrétní dobu rotace (např. 30 dní).
        </PrivacyPolicyNote>

        <PrivacyPolicySectionTitle variant="h6">Third-Party Services</PrivacyPolicySectionTitle>
        <PrivacyPolicyText variant="body1">
          The application does not use third-party analytics or advertising services.
        </PrivacyPolicyText>

        <PrivacyPolicySectionTitle variant="h6">Your Rights</PrivacyPolicySectionTitle>
        <PrivacyPolicyText variant="body1">
          You can request access to your own data, request correction or deletion, and raise an objection to
          processing where applicable.
        </PrivacyPolicyText>
        <PrivacyPolicyNote variant="body2">
          ⚠ TODO (GDPR čl. 13 odst. 2b–d): Chybí tato povinná práva: (1) právo na omezení zpracování (čl. 18),
          (2) právo na přenositelnost údajů (čl. 20), (3) právo podat stížnost u dozorového úřadu — ÚOOÚ,
          Pplk. Sochora 27, 170 00 Praha 7, www.uoou.cz (čl. 77 — toto právo je povinné vždy uvést).
        </PrivacyPolicyNote>
        <PrivacyPolicyNote variant="body2">
          ⚠ TODO (GDPR čl. 13 odst. 2f): Chybí kontaktní adresa/e-mail, kam subjekt může zaslat žádost o uplatnění
          práv. Bez kontaktu nemohou subjekty údajů práva reálně využít.
        </PrivacyPolicyNote>
        <PrivacyPolicyNote variant="body2">
          ⚠ TODO (GDPR čl. 13 odst. 2f): Chybí informace o automatizovaném rozhodování a profilování — i negativní
          prohlášení je povinné: „Neprovádíme automatizované rozhodování ani profilování ve smyslu čl. 22 GDPR.“
        </PrivacyPolicyNote>
      </PrivacyPolicyCard>
    </PrivacyPolicyContainer>
  )
}

export default PrivacyPolicyPage
